<div #yourInfoWrapper>
  <div class="option-wrapper">
    <div class="variant-wrapper my-2 my-md-0">
      <div class="p-3 section-title mt-3 mt-md-0 mb-3 font-size-heading pl-4 theme-light"
        *ngIf="!checkoutService.showChoices() && !checkoutService.allFieldsHiddenForPickup()">
        {{
        (!checkoutService.showChoices() && !checkoutService.allFieldsHiddenForPickup()
        && checkoutService.selectedStore?.settings?.ORDER_FULFILMENT_METHOD === 'PICKUP_AND_RETURN')
        ? ('public.checkout.dropOfInfo' | translate)
        : ('public.checkout.title.pickup' | translate) }}
      </div>
      <app-customer-login></app-customer-login>
      <div class="expandable-content-wrapper">
        <form class="mx-3" [formGroup]="personalInfoForm">
          <!-- Your name -->
          <div class="row" *ngIf="!nameFieldHidden()">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-input-text class="mb-4" inputId="name" autocomplete="name" maxLength="200"
                  [label]="'public.checkout.fullName' | translate" [required]="nameFieldRequired()"
                  [control]="getControl('name')" [isInvalid]="checkoutService.isInvalid(getControl('name'))"
                  [errorText]="
                    getControl('name')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) :
                    getControl('name')?.errors?.whitespace || getControl('name')?.errors?.containsUrl ? ('public.payment.errors.valueNotValid' | translate) : ''
                  " (keyupEvent)="checkFormValidity()"
                  (focusoutEvent)="addOrderMeta('customerName', 'name', 'personalInfoForm')" appPreventEnter />
              </div>
            </div>
          </div>
          <!-- Email -->
          <div class="row" *ngIf="!emailFieldHidden()">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-input-text class="mb-4" inputId="email" autocomplete="email" maxLength="200"
                  [label]="'public.checkout.email' | translate" [required]="emailFieldRequired()"
                  [control]="getControl('email')" [isDisabled]="auth.isUserLoggedIn()"
                  [isInvalid]="(checkoutService.isInvalid(getControl('email')) || getControl('email').errors?.email)"
                  [errorText]="
                    getControl('email')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) :
                    (
                      getControl('email')?.errors?.email ||
                      getControl('email')?.errors?.whitespace ||
                      getControl('email')?.errors?.minlength ||
                      getControl('email')?.errors?.maxlength
                    ) ? ('public.payment.errors.valueNotValid' | translate) : ''
                  " (keyupEvent)="checkFormValidity()"
                  (changeEvent)="addOrderMeta('customerEmail', 'email', 'personalInfoForm')" appPreventEnter />
              </div>
            </div>
          </div>
          <!-- Phone Number -->
          <div class="row" *ngIf="!phoneFieldHidden()">
            <div class="col-md-12">
              <div class="form-group mx-2">
                <app-phone-input [id]="'phone'" [countryCode]="countryCode()" [formControl]="getControl('phone')"
                  [required]="phoneFieldRequired()" [invalidSubmit]="checkoutService.invalidSubmit()"
                  (inputChange)="checkFormValidity(); addOrderMeta('customerPhoneNumber', 'phone', 'personalInfoForm');"
                  (change)="checkFormValidity(); addOrderMeta('customerPhoneNumber', 'phone', 'personalInfoForm');"
                  [countryName]="getCountryNameCode()"/>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- FORM END -->
    </div>
  </div>
  <div class="mx-4">
    <app-customer-save-details
      [name]="getControl('name')?.value"
      [phone]="getControl('phone')?.value"
      [formValid]="personalInfoForm?.valid"
    />
  </div>
</div>
